/**
 * The `rule_type`s of a card raised inside a CONVERSATION — a money, email or
 * settings tool the user asked for there, waiting on their yes there:
 *
 *  • `chat_staged` — the in-app chat or voice, where it is a button in the
 *    conversation that can also be answered in words;
 *  • `call_staged` — the owner's phone call, where it is read back and the
 *    caller's yes approves it;
 *  • `whatsapp_staged` — a receipt sent to Mucka on WhatsApp by someone who
 *    can approve it, answered by the buttons on the WhatsApp reply.
 *
 * Either way it is answered where it was asked for, and it is on no Actions
 * list (`narrowToVisibleCards` rule 4, Tom's ruling of 9 Oct 2026). Its own
 * module, with no directive and no imports, because the server's queries and
 * the client's panel both need it (CLAUDE.md #18).
 */
export const CONVERSATION_RULE_TYPES = ['chat_staged', 'call_staged', 'whatsapp_staged'] as const;

export function isConversationCard(ruleType: string | null | undefined): boolean {
  return (CONVERSATION_RULE_TYPES as readonly string[]).includes(ruleType ?? '');
}

/**
 * The card types a conversation card can be, and so the ones a yes "in
 * words" may approve (`approve_action` with a `staged:` reference) and the chat
 * may redraw: a staged tool call, a receipt sent in the chat, or a day the
 * asker can approve themselves.
 */
export const CONVERSATION_ACTION_TYPES = ['staged_tool', 'receipt_bill', 'day_reshuffle'] as const;

export function isConversationActionType(actionType: string | null | undefined): boolean {
  return (CONVERSATION_ACTION_TYPES as readonly string[]).includes(actionType ?? '');
}
